document.addEventListener("DOMContentLoaded", () => {

    const button = document.querySelector(".js-wallpaper-buy-sample");

    if (!button) return;

    function getCurrentVariantId() {

        // Horizon variant selector
        const variantInput = document.querySelector(
            'form[action*="/cart/add"] input[name="id"]'
        );

        if (variantInput && variantInput.value) {
            return variantInput.value;
        }

        return button.dataset.variantId;

    }

    button.addEventListener("click", async function () {

        button.disabled = true;

        button.classList.add("loading");

        const variantId = getCurrentVariantId();

        try {

            // Clear cart (Buy Now behaviour)
            await fetch("/cart/clear.js", {
                method: "POST"
            });

            // Add sample
            await fetch("/cart/add.js", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({

                    id: variantId,

                    quantity: 1,

                    properties: {

                        "Purchase Type": "Wallpaper Sample",

                        "Sample Size": "A3",

                        "Fulfilment": "Sample Order"

                    }

                })

            });

            window.location.href = "/checkout";

        }

        catch (e) {

            console.error(e);

            alert("Unable to process sample order.");

            button.disabled = false;

            button.classList.remove("loading");

        }

    });

});